import { createSlice, Dispatch, PayloadAction } from "@reduxjs/toolkit";
import axios, { AxiosError, AxiosResponse } from "axios";
import {
  FieldConfiguration,
  FormConfiguration,
  SectionConfiguration,
} from "../components/model/form-configuration";
import { url } from "../components/model/url-endpoint";
import { FieldValues, UseFormSetValue } from "react-hook-form";

const initialState: FormConfiguration = {
  form: {
    id: "",
    uuid: "",
    name: "",
    sections: [],
  },
};

const loadFormSlice = createSlice({
  name: "form",
  initialState,
  reducers: {
    loadFormConfiguration: (
      state,
      action: PayloadAction<FormConfiguration>
    ) => {
      return {
        ...state,
        form: action.payload.form,
      };
    },
  },
});

export const loadFormConfiguration = (
  queryParams: URLSearchParams,
  universalId: string,
  setValue: UseFormSetValue<FieldValues>,
  noReset: boolean = false
) => {
  return (dispatch: Dispatch<any>) => {
    axios
      .post(url + "load", {
        coi: queryParams.get("coi"),
        form: { uuid: queryParams.get("form"), universalId: universalId },
      })
      .then((response: AxiosResponse) => {
        response.data.form.sections.forEach((section: SectionConfiguration) => {
          section.fields?.forEach((field: FieldConfiguration) => {
            field.value
              ? setValue(field.id, field.value[0])
              : setValue(field.id, "");
          });
        });
        dispatch(loadFormActions.loadFormConfiguration(response.data));
      })
      .catch((error: AxiosError) => {
      });
  };
};

export default loadFormSlice;
export const loadFormActions = loadFormSlice.actions;
